/**
 * 픽셀을 엑셀 포인트 높이로 변환
 * @param pixel - 픽셀 값
 * @param dpi - DPI (기본값: 96)
 * @returns 엑셀 포인트 값
 * @public
 */
export function pixelToPtHeight(pixel: number, dpi = 96) {
  // 96dpi 96px = 72pt 1px = 72/96
  const inches = pixel / dpi;
  const excelPoints = inches * 72;
  return excelPoints;
}

/**
 * 픽셀을 엑셀 포인트 너비로 변환
 * @param pixel - 픽셀 값
 * @param dpi - DPI (기본값: 96)
 * @returns 엑셀 포인트 값
 * @public
 */
export function pixelToPtWidth(pixel: number, dpi = 96) {
  // 96dpi 96px = 72pt 1px = 72/96
  const onePixel = 72 / dpi;
  const excelPoints = pixel / onePixel / 9; // excel의 default 글자 크기가 11
  return excelPoints;
}

/**
 * 엑셀 포인트 높이를 픽셀로 변환
 * @param excelPoints - 엑셀 포인트 값
 * @param dpi - DPI (기본값: 96)
 * @returns 픽셀 값
 * @public
 */
export function ptHeightToPixel(excelPoints: number, dpi = 96) {
  // 96dpi 96px = 72pt 1pt = 96/72
  const inches = excelPoints / 72;
  const pixel = inches * dpi;
  return pixel;
}
